<p-toast position="top-right" key="msj"></p-toast>
<!--<p-messages></p-messages>-->
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" acceptLabel="Aceptar" rejectLabel="Cancelar"
  rejectButtonStyleClass="p-button-text">
</p-confirmDialog>

<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>
<div class="d-flex justify-content-center">
  <div class="container-fluid" style="width: 100%;">
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card card-shadow sinborde">
          <div class="card-header sinborde" style="background: none; ">
            <div class="cardicono rounded">
              <i class="pi pi-money-bill mt-3" style="font-size: 2rem; color: #fff;"></i>
            </div>
            <header style="left: 11%; top: 5%;">
              <div style="display:inline"> Gestion de</div>

              <div style="color:rgb(29, 102, 212);display:inline;" class="ml-3 ">Bono por
                Recomendación Acumulado</div>
              <!-- - {{dia|date:'dd/MM/yyyy'}}
                 -->
            </header>




            <div class="row d-flex justify-content-around mt-5">
              <div class="col-md-8 row gap-3">
                <div class="col-md-1"></div>


                <!-- filtro de semanas -->
                <div class="col-md-4">
                  <p-dropdown [options]="lstSemanas" autoWidth="false" [style]="{'width':'100%'}"
                    (onChange)="onCiudadChange($event)" placeholder="Seleccione Semana*" [(ngModel)]="selectedSemana"
                    optionLabel="nom_semana" [showClear]="false">
                    <ng-template let-target pTemplate="item">
                      <div class="ui-helper-clearfix" style="position: relative;height:25px;"
                        pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                        <span style="font-size:14px;float:left;margin-top:4px">{{target.nom_semana}}</span>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <div style="min-height: 18px;" class="mt-1">
                    <div *ngIf="selectedSemana!=null">
                      <div class="row">
                        <div style="color: rgb(42, 172, 42); font-size: 14px;" class="col-sm-6 text-left "><b>Inicio:
                            {{selectedSemana.fec_inicio | date: 'dd/MM/yyyy' }}</b></div>
                        <div style="color: rgb(42, 172, 42); font-size: 14px;" class="col-sm-6 text-right "><b>Fin:
                            {{selectedSemana.fec_fin | date: 'dd/MM/yyyy' }}</b></div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- filtro de ciudades -->
                <div class="col-md-4 ">
                  <p-dropdown [(ngModel)]="id_ciudad" [options]="lstCiudades" optionLabel="nombre" optionValue="id"
                    (onChange)="onCiudadChange($event)" placeholder="Filtrar por Ciudad" [showClear]="false"
                    [disabled]="dsblstCiudades" [style]="{'width':'100%'}">
                  </p-dropdown>
                </div>


                <!-- ----------boton principal para el filtro  inicial------------------- -->
                <div class="col-md-1 ">
                  <button pButton pRipple type="button" class="btn custom-filtrar" (click)="FiltrarFechaDiariaRuta();"
                    label="Filtrar" icon="pi pi-filter" iconPos="left"></button>
                </div>
                <!-- ----------boton principal de los reportes en excel------------------- -->

                <div class="col-md-1"></div>
              </div>
              <div class="col-md-4 gap-3 d-flex justify-content-end ">
                <div>
                  <div class="col-md-6">
                    <div class="row d-flex justify-content-around">
                      <div class="col-md-9">
                        <p-calendar [(ngModel)]="anio_filtro" view="year" [showIcon]="true" dateFormat="yy"
                          inputId="yearpicker" [style]="{'width':'100%'}" pTooltip="Año de Semanas a Consultar"
                          tooltipPosition="top"></p-calendar>
                      </div>
                      <div class="col-md-3">
                        <button pButton pRipple label="Cargar" class="custom-buttoncargar" icon="pi pi-filter"
                          (click)="cargarListadoDeSemanasAnio_cast(anio_filtro);"
                          pTooltip="Cargar Semanas del Año"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-1"></div>
              </div>



            </div>
            <div class="card-content">
              <div class="row mt-3">
                <!-- informacio  -->
                <p-table #dt1 [value]="lstBonoRecomendacion" [tableStyle]="{'min-width': '40rem'}"
                  styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="480px"
                  scrollDirection="horizontal" responsiveLayout="scroll"
                  [globalFilterFields]="['nom_chofer','desc_puesto','desc_ciudad_hm','desc_tipo_transporte','nom_chofer_recomendado']"
                  [paginator]="true" paginatorPosition="bottom" [rows]="30"
                  [showCurrentPageReport]="true"
                  currentPageReportTemplate="{first} a {last} de {totalRecords} Registros" [loading]="loading"
                  [resizableColumns]="false">
                  <ng-template pTemplate="caption">
                    <div class="row d-flex justify-content-between">
                      <!-- Botón alineado a la izquierda -->
                      <div class="col-md-4 d-flex justify-content-center gap-3">
                        <button type="button" *ngIf="mostraragregar" class="btn custom-agregar "
                          (click)="mostrarModalAgregar();" tooltipPosition="top">
                          <b>Agregar&nbsp;Bono&nbsp;<i class="pi pi-plus-circle"></i></b>
                        </button>

                        <button type="button" *ngIf="mostraragregar" class="btn custom-ver " (click)="dialogVerMas();"
                          tooltipPosition="top">
                          <b>Mostrar&nbsp;Bono&nbsp;<i class="pi pi-arrow-up-right"></i></b>
                        </button>
                      </div>

                      <!-- Filtro alineado a la derecha -->
                      <div class="col-md-auto">
                        <span class="p-input-icon-left">
                          <i class="pi pi-search" style="margin-right: 5px;"></i>
                          <input pInputText
                            pTooltip="Buscar por: nombre del acreedor, nombre del recomendado, ciudad o puesto"
                            type="text" tooltipPosition="top" (input)="applyFilterGlobal($event, 'contains')"
                            placeholder="Buscar" style="margin-left: 5px;" />
                        </span>
                      </div>
                    </div>

                  </ng-template>

                  <!-- tabulado -->
                  <ng-template pTemplate="header">
                    <tr>
                      <!-- <th class="text-center" >#</th> -->
                      <th class="text-center">#Chofer</th>
                      <th class="text-center" pSortableColumn="nom_chofer">Acreedor<p-sortIcon
                          field="nom_chofer"></p-sortIcon></th>
                      <th class="text-center" pSortableColumn="id_ciudad_hm"> Ciudad<p-sortIcon
                          field="id_ciudad_hm"></p-sortIcon></th>
                      <th class="text-center" pSortableColumn="desc_puesto">Puesto<p-sortIcon
                          field="desc_puesto"></p-sortIcon></th>
                      <th class="text-center">Alta Recomendado</th>
                      <th class="text-center">Semana Pago</th>
                      <th class="text-center">Semana inicio </th>
                      <th class="text-center">Semana fin </th>
                      <th class="text-center" pSortableColumn="desc_puesto">Recomendado<p-sortIcon
                          field="desc_puesto"></p-sortIcon></th>
                      <th class="text-center" pSortableColumn="total_a_pagar">Total<p-sortIcon
                          field="total_a_pagar"></p-sortIcon></th>
                      <th class="text-center" pSortableColumn="clv_activo">Estatus<p-sortIcon
                          field="clv_activo"></p-sortIcon></th>
                      <th></th>

                    </tr>

                  </ng-template>
                  <ng-template pTemplate="body" let-data let-index>
                    <tr>
                      <!-- <td class="text-center"><b>{{data.index + 1}}</b></td> -->
                      <td class="text-center"><b>{{data.cod_chofer }}</b></td>
                      <td class="justify-content-left"><b>{{data.nom_chofer }}</b></td>
                      <td class="text-center">{{ data.desc_ciudad_hm}}</td>
                      <td class="text-left pl-3"
                        [ngStyle]="{'color': data.desc_puesto ==='DRIVER'? 'rgba(60,  148, 224)' : 'rgba(60, 224, 122  )'}">
                        <b>{{ data.desc_puesto }}</b>
                      </td>
                      <td class="text-center">{{ data.fec_alta | date: 'dd/MM/yyyy' }}</td>
                      <td class="text-center">{{ data.id_semana }}</td>
                      <td class="text-center">{{data.semana_hm_inicio | date: 'dd/MM/yyyy'}}</td>
                      <td class="text-center">{{data.semana_hm_fin | date: 'dd/MM/yyyy'}}</td>
                      <td class="justify-content-left">{{data.nom_chofer_recomendado}}</td>
                      <td class="text-center" style="color: rgb(22, 48, 220)"><b>{{ data.imp_bono_recomendacion |
                          currency:
                          'USD' }}</b></td>
                      <td class="text-center" [ngStyle]="{
                                'color': data.clv_activo === 1 ? 'orange' : (data.clv_activo === 2 ? 'green' : 'red')
                              }">
                        <b>
                          {{data.desc_estatus}}
                          <!-- {{ data.clv_activo === 1 ? 'REQUIERE AUTORIZAR' : (data.clv_activo === 4 ? 'BONO RECHAZADO' :
                          'BONO ACEPTADO' ) }} -->
                        </b>
                      </td>
                      <td>
                        <div class="d-flex justify-content-around  gap-3">


                          <div *ngIf="data.clv_activo !== 2">
                            <button class="btn btn-success" pTooltip="Aprobar bono"
                              [disabled]="data.clv_activo === 4 || data.clv_activo === 2"
                              (click)="AprobarBono(data, 2)">
                              <i class="pi pi-check"></i>
                            </button>
                          </div>

                          <div *ngIf="data.clv_activo == 2">
                            <button class="btn btn-primary" [disabled]="data.clv_activo === 4 "
                              pTooltip="Cancelar Aprobar Bono" (click)="AprobarBono(data, 6)">
                              <i class="pi pi-arrow-right-arrow-left"></i>
                            </button>
                          </div>



                          <div *ngIf="data.clv_activo == 4">
                            <button class="btn btn-dark" [disabled]="data.clv_activo === 2" pTooltip="Cancelar Rechazo"
                              (click)="AprobarBono(data,5)">
                              <i class="pi pi-arrow-right-arrow-left"></i>
                            </button>
                          </div>
                          <div *ngIf="data.clv_activo !== 4">
                            <button class="btn btn-warning" [disabled]="data.clv_activo === 2 || data.clv_activo === 4"
                              pTooltip="Rechazar Bono" (click)="dialogRechazo(data)">
                              <i class="pi pi-times"></i>
                            </button>
                          </div>


                          <button [disabled]="data.clv_activo === 2 || data.clv_activo === 4" class="btn btn-danger"
                            pTooltip="Eliminar Bono" (click)="AprobarBono(data, 3)">
                            <i class="pi pi-trash"></i>
                          </button>


                        </div>
                      </td>

                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="11" style="text-align: center; padding: 2rem;">
                        <i class="pi pi-info-circle" style="font-size: 2rem; color: #888;"></i>
                        <p style="margin-top: 0.5rem; color: #888; font-weight: bold;">Sin Registros</p>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="footer">
                    <tr>
                      <td colspan="2" class="text-right"></td>
                      <td colspan="9" class="text-right" style="color: rgb(169, 12, 12);">Total de bono por
                        recomendación</td>
                      <td style="color: rgb(13, 164, 13);">{{ imp_total_genral | currency: 'USD'}}</td>
                    </tr>
                  </ng-template>
                </p-table>

                <!-- pie de pagina -->
              </div>
              <div class=" mt-3 d-flex justify-content-center">

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>


    <!-- pdialog de agregar  -->
    <p-dialog [resizable]="false" [draggable]="false" (onHide)="cancelarVentanaModalPdialog()" [(visible)]="dspCliente"
      [style]="{width: '55vw','height': '600px', 'overflow-x': 'hidden'} " [transitionOptions]="'0ms'">
      <ng-template pTemplate="header">
        {{ texto_operacion}}
      </ng-template>
      <ng-template pTemplate="content">
        <div>
          <div class="card-content ">
            <form class="form_cliente" [formGroup]="reactivebonoRecomendacion" (ngSubmit)="validarBono(7)">
              <div class="ml-2">
                <div class="row mt-1 d-flex justify-content-start">
                  <div class="col-sm-12">
                    <span class="title-light">Seleccione la información solicitada
                      <i class="pi pi-cog" style="size: 2rem;">
                      </i>
                    </span>
                  </div>
                </div>

                <!--
                <div class="row ">
                  <div class="col-md-6 mt-4">
                    <span class="p-float-label">
                      <p-dropdown [options]="lstSemanas" formControlName="selectedSemana" optionLabel="nom_semana"
                        [placeholder]="'Seleccione Semana*'" [style]="{'width':'100%'}" [showClear]="false">
                        <ng-template let-target pTemplate="item">
                          <div class="ui-helper-clearfix" style="position: relative;height:25px;"
                            pTooltip="{{getTargetDescription(target)}}" tooltipPosition="top">
                            <span style="font-size:14px;float:left;margin-top:4px">{{target.nom_semana}}</span>
                          </div>
                        </ng-template>
                      </p-dropdown>
                      <label for="selectedSemana" style="font-weight: bold;">Seleccione Semana*</label>
                    </span>

                    <div class="mt-1">
                      <div class="row">
                        <div style="color: rgb(42, 172, 42); font-size: 13px;" class="col-sm-6 text-left " >
                          <b>Inicio: {{ reactivebonoRecomendacion.controls['fec_inicio'].value | date:'dd/MM/yyyy'
                            }}</b>
                        </div>
                        <div style="color: rgb(42, 172, 42); font-size: 13px;" class="col-sm-6 text-right ">
                          <b>Fin: {{ reactivebonoRecomendacion.controls['fec_fin'].value | date:'dd/MM/yyyy' }}</b>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">


                  </div>
                </div> -->

                <div class="row ">
                  <!-- colaboradores  que recibira el apoyo-->
                  <div class="row  mt-4">
                    <div class="col-md-6 ">
                      <span class="p-float-label">
                        <p-dropdown [options]="lstChoferes" optionLabel="nombre_completo" formControlName="cod_chofer"
                          appendTo="body" [showClear]="false" [filter]="true" [filterBy]="'nombre_completo'"
                          [style]="{'width':'100%'}" placeholder="Acreedor'" optionValue="cod_chofer"
                          (onChange)="changedp($event)">
                        </p-dropdown>

                        <label for="cod_chofer" style="font-weight: bold;">Seleccione Acreedor</label>
                      </span>
                    </div>

                    <div class="col-md-6 ">
                      <span class="p-float-label">
                        <p-dropdown [options]="lstCiudad2" optionLabel="nombre" formControlName="id_ciudad_hm"
                          [placeholder]="'Ciudad Acreedor'" [showClear]="false" [style]="{'width':'100%'}"
                          optionValue="id" pTooltip="{{mssgListaCiudades}}">
                        </p-dropdown>
                        <label for="id_ciudad_hm" style="font-weight: bold;">Seleccione Ciudad Acreedor</label>
                      </span>
                    </div>
                  </div>

                  <!-- colaboradores  que fue recomendado -->
                  <div class="row  mt-3">
                    <div class="col-md-6 mt-3">
                      <span class="p-float-label">
                        <p-dropdown [options]="lstChoferes" optionLabel="nombre_completo"
                          [placeholder]="'Seleccione Colaborador'" formControlName="cod_chofer_recomendado"
                          [showClear]="false" [filter]="true" [filterBy]="'nombre_completo'" [style]="{'width':'100%'}"
                          optionValue="cod_chofer" (onChange)="changedprecomendado($event)" appendTo="body">
                        </p-dropdown>
                        <label for="cod_chofer_recomendado" style="font-weight: bold;">Seleccione Recomendado</label>
                      </span>
                    </div>

                    <div class="col-md-3 mt-3">
                      <span class="p-float-label">
                        <p-dropdown [options]="lstCiudad2" optionLabel="nombre" formControlName="id_ciudad_recomendado"
                          [placeholder]="'Seleccione Ciudad del colaborador recomendado'" [showClear]="false"
                          [style]="{'width':'100%'}" optionValue="id" pTooltip="{{mssgListaCiudades}}">
                        </p-dropdown>
                        <label for="id_ciudad_recomendado" style="font-weight: bold;">Ciudad Recomendado</label>
                      </span>
                    </div>
                    <div class="col-md-3 mt-3">
                      <span class="p-float-label">
                        <p-calendar formControlName="fec_alta" dateFormat="yy-mm-dd" [style]="{'width':'100%'}"
                          appendTo="body">
                        </p-calendar>
                        <label for="fec_alta" style="font-weight: bold;">Fecha Alta</label>
                      </span>
                    </div>

                  </div>
                </div>
                <div class="row col-12 mt-3">

                  <span class="p-float-label" style="display:block; position:relative;">
                    <textarea pInputTextarea formControlName="observacion" rows="2" maxlength="500" style="width: 100%;"
                      (input)="updateCharCount()"></textarea>
                    <label for="observacion">&nbsp;Observación</label>
                  </span>

                  <!-- contador debajo -->
                  <div style="text-align: right; font-size: 12px; color: gray; margin-top: 2px;">
                    {{ remainingChars }} caracteres restantes
                  </div>


                </div>


                <!-- --------------fin drodowns------------- -->
                <div class="row d-flex ">
                  <div class="col-md-5  mt-6 justify-content-start">

                  </div>

                  <div class="col-md-3 mt-7 justify-content-center">
                    <button class="btn btn-primary form-control" type="submit"
                      [disabled]="!reactivebonoRecomendacion.controls['cod_chofer'].valid  || !reactivebonoRecomendacion.controls['cod_chofer_recomendado'].valid || !reactivebonoRecomendacion.controls['selectedSemana'].valid"
                      pTooltip="Almacenar informacion" tooltipPosition="right">
                      <span class="text-white">Guardar</span>
                      <i class="pi pi-save text-white"></i>
                    </button>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarVentanaModalPdialog()"></button>
      </ng-template>
    </p-dialog>


    <!-- dialog para rechar un bono -->
    <p-dialog [resizable]="false" [draggable]="false" (onHide)="cancelarDialogRechazo()" [(visible)]="dspRechazo"
      [style]="{width: '40vw','height': '500px', 'overflow-x': 'hidden'} " [transitionOptions]="'0ms'">
      <ng-template pTemplate="header">
        Motivo del rechazo del bono
      </ng-template>
      <ng-template pTemplate="content">
        <div>
          <div class="card-content ">
            <form class="form_cliente" [formGroup]="reactivebonoRecomendacion" (ngSubmit)="cancelarBono(4)">
              <div class="ml-2">
                <div class="row mt-1 d-flex justify-content-start">
                  <div class="col-sm-12">
                    <span class="title-light">Indique el motivo del rechazo del bono de recomendación
                      <i class="pi pi-cog" style="size: 2rem;">
                      </i>
                    </span>
                  </div>
                </div>


                <div class="row col-12 mt-3">

                  <span class="p-float-label" style="display:block; position:relative;">
                    <textarea pInputTextarea formControlName="observacion" rows="4" maxlength="500" style="width: 100%;"
                      (input)="updateCharCount()"></textarea>
                    <label for="observacion">&nbsp;Observación</label>
                  </span>

                  <!-- contador debajo -->
                  <div style="text-align: right; font-size: 12px; color: gray; margin-top: 2px;">
                    {{ remainingChars }} caracteres restantes
                  </div>


                </div>


                <!-- --------------fin drodowns------------- -->
                <div class="row d-flex justify-content-center">


                  <div class="col-md-3 mt-5 ">
                    <button class="btn btn-primary form-control" type="submit"
                      [disabled]="!reactivebonoRecomendacion.controls['observacion'].valid"
                      pTooltip="Almacenar informacion" tooltipPosition="right">
                      <span class="text-white">Guardar&nbsp;</span>
                      <i class="pi pi-save text-white"></i>
                    </button>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarDialogRechazo()"></button>
      </ng-template>
    </p-dialog>



    <!-- p-dialog de reportes excel ------------
    <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbsReportes"
      [style]="{'width': '60vw','height':'620px'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
      (onHide)="cancelarModalReportes()">
      <ng-template pTemplate="header">
        Generar Reporte De Excel
      </ng-template>
      <ng-template pTemplate="content">
        <div class="mt-5">
          <hr class="style-two">
          <div class="row">
            <div class="col-md-3">
              <p class="texto-pesado">Reporte De Prima Vacacional</p>
            </div>
            <div class="col-md-2">
              <select class="form-control" style="width: 100%;" [(ngModel)]="num_anio">
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <p-dropdown [(ngModel)]="id_ciudad_principal" [options]="lstCiudades" optionLabel="nombre" optionValue="id"
                placeholder="Filtrar por Ciudad" [showClear]="false" [disabled]="dsblstCiudades">
              </p-dropdown>
            </div>
            <div class="col-md-3 ml-6">
              <button type="button" class="btn btn-outline-success" style="width: 100%;"
                (click)="exportarExcel()" [disabled]="ButtonExportExcel">
                Exportar <i class="pi pi-file-export"></i>
              </button>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-2 text-center">
              <i class="pi pi-spin pi-spinner" *ngIf="loading_reporte1"></i>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelarModalReportes();"></button>
      </ng-template>
    </p-dialog> -->





    <!-- ---DIALOG DE VER MAS -------------------------- -->
    <p-dialog [resizable]="false" [draggable]="false" (onHide)="cancelardialogVerMas()" [(visible)]="dspVerMas"
      [style]="{width: '85vw','height': '900px', 'overflow-x': 'hidden'} " [transitionOptions]="'0ms'">
      <ng-template pTemplate="header">
        Consulta bono por recomendación
      </ng-template>
      <ng-template pTemplate="content">
        <div>
          <div class="card-content ">

            <div class="ml-2">
              <div class="row mt-1 d-flex justify-content-start">
                <div class="col-sm-12">
                  <span class="title-light">Seleccione los criterios de búsqueda
                    <i class="pi pi-cog" style="size: 2rem;">
                    </i>
                  </span>
                </div>
              </div>
              <div class="row gap-3  mt-4 mb-3">



                <div class="col-md-4 justify-content-start">
                  <span class="p-float-label">
                    <p-dropdown [options]="lstCiudades" optionLabel="nombre" [(ngModel)]="id_ciudad_hm_vermas"
                      appendTo="body" [showClear]="false" [style]="{'width':'100%'}" placeholder="Seleccione Ciudad"
                      optionValue="id" (onChange)="changedp($event)">
                    </p-dropdown>

                    <label for="cod_chofer" style="font-weight: bold;">Seleccione Ciudad</label>
                  </span>
                </div>
                <div class="col-md-3 justify-content-start">
                  <span class="p-float-label">
                    <p-dropdown [options]="lstEstatus" optionLabel="descripcion" [(ngModel)]="clv_activo"
                      appendTo="body" [showClear]="false" [style]="{'width':'100%'}" placeholder="Seleccione Estatus"
                      optionValue="clv_activo" (onChange)="changedp($event)">
                    </p-dropdown>

                    <label for="cod_chofer" style="font-weight: bold;">Seleccione Estatus</label>
                  </span>
                </div>



                <!-- ----------boton principal para el filtro  inicial------------------- -->
                <div class="col-md-2 d-flex justify-content-start">
                  <button pButton pRipple type="button" class="btn custom-filtrar" (click)="FiltrarVerMas();"
                    label="Filtrar" icon="pi pi-filter" iconPos="left"></button>
                </div>
                <!-- ----------boton principal de los reportes en excel------------------- -->

                <div class="col-md-2 d-flex justify-content-end">
                  <button type="button" class="btn custom-exportar " (click)="exportarExcel()"
                    [disabled]="ButtonExportExcel">
                    <b>Exportar</b>&nbsp;<i class="pi pi-file-export"></i>
                  </button>

                </div>

              </div>

              <!-- informacio  -->
              <p-table #dt2 [value]="lstBonoVerMas" [tableStyle]="{'min-width': '40rem'}"
                styleClass="p-datatable-sm p-datatable-striped" [scrollable]="true" scrollHeight="380px"
                scrollDirection="horizontal" responsiveLayout="scroll"
                [globalFilterFields]="['nom_chofer','desc_puesto','desc_ciudad_hm','desc_tipo_transporte','nom_chofer_recomendado']"
                [paginator]="true" [rows]="30" [rowsPerPageOptions]="[10,15,20,30,50]" [showCurrentPageReport]="true"
                [resizableColumns]="false" currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
                [loading]="loading1">
                <ng-template pTemplate="caption">
                  <div class="row d-flex justify-content-between">
                    <!-- Botón alineado a la izquierda -->
                    <div class="col-md-4 d-flex justify-content-center gap-3">

                    </div>

                    <!-- Filtro alineado a la derecha -->
                    <div class="col-md-auto">
                      <span class="p-input-icon-left">
                        <i class="pi pi-search" style="margin-right: 5px;"></i>
                        <input pInputText
                          pTooltip="Buscar por: nombre del acreedor, nombre del recomendado, ciudad o puesto"
                          type="text" (input)="applyFilterGlobal2($event, 'contains')" placeholder="Buscar"
                          style="margin-left: 5px;" />
                      </span>
                    </div>
                  </div>

                </ng-template>

                <!-- tabulado -->
                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-center">#Chofer</th>
                    <th class="text-center" pSortableColumn="nom_chofer">Acreedor<p-sortIcon
                        field="nom_chofer"></p-sortIcon></th>
                    <th class="text-center" pSortableColumn="id_ciudad_hm">Ciudad<p-sortIcon
                        field="id_ciudad_hm"></p-sortIcon></th>
                    <th class="text-center" pSortableColumn="desc_puesto">Puesto<p-sortIcon
                        field="desc_puesto"></p-sortIcon></th>
                    <th class="text-center">Semana</th>
                    <th class="text-center">Semana Inicio</th>
                    <th class="text-center">Semana Fin</th>
                    <th class="text-center" pSortableColumn="desc_puesto">Recomendado<p-sortIcon
                        field="desc_puesto"></p-sortIcon></th>
                    <th pSortableColumn="total_a_pagar">Total<p-sortIcon field="total_a_pagar"></p-sortIcon></th>
                    <th class="text-center">Estatus</th>

                  </tr>

                </ng-template>
                <ng-template pTemplate="body" let-data let-index>
                  <tr>
                    <td class="text-center"><b>{{data.cod_chofer }}</b></td>
                    <td class="justify-content-left"><b>{{data.nom_chofer }}</b></td>
                    <td class="text-center">{{ data.desc_ciudad_hm}}</td>
                    <td class="text-left pl-3"
                      [ngStyle]="{'color': data.desc_puesto ==='DRIVER'? 'rgba(60,  148, 224)' : 'rgba(60, 224, 122  )'}">
                      <b>{{ data.desc_puesto }}</b>
                    </td>
                    <td class="text-center">{{ data.id_semana }}</td>
                    <td class="text-center">{{data.semana_hm_inicio | date: 'dd/MM/yyyy'}}</td>
                    <td class="text-center">{{data.semana_hm_fin | date: 'dd/MM/yyyy'}}</td>
                    <td class="justify-content-left">{{data.nom_chofer_recomendado}}</td>
                    <td class="text-center" style="color: rgb(22, 48, 220)"><b>{{ data.imp_bono_recomendacion |
                        currency:
                        'USD' }}</b></td>
                    <td class="text-center" [ngStyle]="{
                        'color': data.clv_activo === 1 ? 'orange' : (data.clv_activo === 2 ? 'green' : 'red')
                      }">
                      <b>{{data.desc_estatus}}
                        <!-- {{ data.clv_activo === 1 ? 'REQUIERE AUTORIZAR' : (data.clv_activo === 4 ? 'BONO RECHAZADO' :
                          'BONO ACEPTADO' ) }} -->
                      </b>
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="15" style="text-align: center; padding: 2rem;">
                      <i class="pi pi-info-circle" style="font-size: 2rem; color: #888;"></i>
                      <p style="margin-top: 0.5rem; color: #888; font-weight: bold;">Sin Registros</p>
                    </td>
                  </tr>
                </ng-template>
              </p-table>





            </div>

          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
          (click)="cancelardialogVerMas()"></button>
      </ng-template>
    </p-dialog>

  </div>
